import * as React from "react";

import { Label } from "../label";
import { cn } from "../../lib/utils";

export interface RequiredLabelProps
  extends React.ComponentPropsWithoutRef<typeof Label> {
  required?: boolean;
}

export function RequiredLabel({
  children,
  className,
  required = false,
  ...props
}: RequiredLabelProps) {
  return (
    <Label className={cn(className)} {...props}>
      {children}
      {required ? <span aria-hidden="true" className="ml-0.5 text-red-600">*</span> : null}
    </Label>
  );
}

export default RequiredLabel;
